/* eslint-disable react/sort-comp */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import List from 'yoda-core-components/lib/components/List/List';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import * as styles from './ShippingAndReturns.css';
import { getIrisReturnsContent, getIrisContent } from '../../actions/ProductContentAction';
import { openModalAnalytics } from '../../actions/AnalyticsAction';
import selectShippingTags from '../../selectors/Bundle/BundleShippingTagsSelector';
import ShippingAndReturnsIrisLazyWrapper from '../ShippingAndReturnsIris/ShippingAndReturnsIrisLazy';

const cx = classNames.bind(styles);

class ShippingAndReturns extends Component {
    static sameDayPickup = 'same day pick up';

    static defaultProps = {
        productContent: {},
        dataAutomationId: ' ',
        actions: {},
        productShippingTags: [],
        productDetails: {},
        generalInfo: [],
        isMobileSliderPDExists: false,
    };

    static propTypes = {
        productContent: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        dataAutomationId: PropTypes.string,
        actions: PropTypes.objectOf(PropTypes.func),
        productShippingTags: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        productDetails: PropTypes.oneOfType([PropTypes.object]),
        generalInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isMobileSliderPDExists: PropTypes.bool,
    };

    constructor() {
        super();

        this.state = {
            isModalOpen: false,
            modalOverElementTopCss: 0,
        };
    }

    /* istanbul ignore next */
    componentWillReceiveProps(nextState) {
        if (this.state.isModalOpen) {
            if (nextState.productContent.body && nextState.productContent.body !== 'loading...') {
                this.props.actions.openModalAnalytics(nextState.productContent.title);
            }
        }
    }

    openModal(tagId) {
        const { actions, isMobileSliderPDExists } = this.props;
        this.props.productContent.body = 'loading...';
        let modalOverElementCssVal = 0;
        /* istanbul ignore next */
        if (isMobileSliderPDExists) {
            const panelContentElement = document.querySelector(
                'div[data-automation-id="mobileSliderPD-at-panel-content"]'
            );
            if (panelContentElement) {
                panelContentElement.style.overflowY = 'hidden';
                modalOverElementCssVal = panelContentElement.scrollTop;
            }
        }
        switch (tagId) {
            default:
                break;

            case 'returns':
                this.props.productContent.body = '';
                break;

            case 'appliance-haul-away-services':
                actions.getIrisContent(tagId);
                break;

            case 'truck-delivery':
                this.props.productContent.title = 'Truck Delivery Information';
                this.props.productContent.body = `<p>You will be contacted to set up a delivery date
                after product has arrived to delivery agent. Delivery agent will contact you the day
                prior to delivery with a two-hour delivery window plus contact you approximately 30
                minutes prior to actual delivery. </br>
                Please allow up to six weeks from the time of sale for custom items.
                 If you have customer service questions,</br>
                <ul>
                <li> &#9864 Furniture/Mattresses Customer Service:
                <strong> 1-800-442-7902 </strong> </li>
                <li> &#9864 All other products: <strong> 1-800-322-1189 </strong> </li>
                </ul>
                After delivery, you may be contacted about your satisfaction. All contacts
                 may be automated calls to the number you provided for delivery.</p>`;
                actions.openModalAnalytics(this.props.productContent.title);
                break;
        }
        this.setState({
            isModalOpen: true,
            modalOverElementTopCss: modalOverElementCssVal,
        });
    }

    closeModal = () => {
        this.setState({
            isModalOpen: false,
            modalOverElementTopCss: 0,
        });
        if (!__SERVER__) {
            const mobileSliderContentElement = document.querySelector(
                'div[data-automation-id="mobileSliderPD-at-panel-content"]'
            );
            /* istanbul ignore next */
            if (mobileSliderContentElement) {
                mobileSliderContentElement.style.overflowY = '';
            }
        }
    };

    renderShippingTagsContent = (dataItem, index) => {
        const { productDetails, dataAutomationId } = this.props;

        if (
            dataItem.title.toLowerCase() === ShippingAndReturns.sameDayPickup &&
            !productDetails.bopisEligibility
        ) {
            return null;
        }

        const returnsPolicyStyle = dataItem.id === 'returns' ? [''] : ['capitalize'];

        return (
            <div data-automation-id="shipping-info-block">
                <span data-automation-id="shipping-info-icons" className={cx('shippingTagIcon')}>
                    <Icon
                        iconType="svg"
                        pathClassName={cx('iconPath')}
                        className={cx('svg-icon')}
                        width={dataItem.imgDimention}
                        height={dataItem.imgDimention}
                        viewBox="0 0 24 24"
                    >
                        {dataItem.iconComponent}
                    </Icon>
                </span>
                <h3 data-automation-id="shipping-info-title" className={cx('shippingTagTitle')}>
                    {' '}
                    {dataItem.title}
                </h3>
                <p data-automation-id="shipping-info-desc" className={cx('shippingTagDesc')}>
                    {' '}
                    {dataItem.html}
                    {dataItem.link ? (
                        <Button
                            buttonType="Link"
                            className={dt(['sm:!font-normal', ...returnsPolicyStyle])}
                            automationId={`${dataAutomationId}-${index}-link-${dataItem.title}`}
                            aria-label={`link-${dataAutomationId}-${index}`}
                            overlayAutomationId="modal-shipping-and-returns"
                            onClick={() => this.openModal(dataItem.id)}
                            size="btnSm"
                        >
                            {dataItem.link}
                        </Button>
                    ) : null}
                </p>
            </div>
        );
    };

    render() {
        const { dataAutomationId, productContent, productShippingTags, generalInfo } = this.props;
        const generalInfoStyle = generalInfo ? ['smOnly:pb-3'] : [''];
        const { modalOverElementTopCss } = this.state;
        const modelOverlaystyle = {
            top: `${modalOverElementTopCss}px`,
        };
        return (
            <div className={cx('ShippingOptionsContainer')}>
                <div
                    className={[
                        cx('ShippingAndReturnsContainer'),
                        dt(['md:pb-3', ...generalInfoStyle]),
                    ].join(' ')}
                >
                    <ErrorBoundary>
                        <List
                            childRenderer={this.renderShippingTagsContent}
                            datasource={productShippingTags}
                            direction="Vertical"
                            itemStyleClass={styles.tagsItem}
                            listStyleClass={styles.tagsList}
                            automationId={`${dataAutomationId}-List`}
                        />
                    </ErrorBoundary>
                </div>
                <ErrorBoundary>
                    <ModalBox
                        showModal={this.state.isModalOpen}
                        onClose={this.closeModal}
                        defaultHeader
                        automationId="Tags-popup"
                        overlayAutomationId="modal-shipping-and-returns"
                        modalTheme={styles.pdpModalCustomWidth}
                        modalBlockTheme={styles.pdpCustomModalBlock}
                        modalContentTheme={styles.pdpModalCustomContentHeight}
                        customOverlayStyle={modelOverlaystyle}
                    >
                        <div className={cx('ShippingModalContainer')}>
                            {productContent.body && (
                                <div>
                                    <h3 className={styles.modalTitle}>{productContent.title}</h3>
                                    {/* eslint-disable react/no-danger */}
                                    <div
                                        className={cx('ShippingModalContent')}
                                        dangerouslySetInnerHTML={{
                                            __html: productContent.body,
                                        }}
                                    />
                                </div>
                            )}
                            {productContent && !productContent.body && (
                                <ShippingAndReturnsIrisLazyWrapper />
                            )}
                        </div>
                    </ModalBox>
                </ErrorBoundary>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    productContent: state.productContent,
    productShippingTags: selectShippingTags(state),
    productDetails: state.productDetails,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getIrisReturnsContent,
            openModalAnalytics,
            getIrisContent,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingAndReturns);
